import Zones from "../../Portal/Accessor/Zone/Zones";
import ZoneDetailV001 from "../../Portal/Accessor/Zone/V001/ZoneDetailV001";
import MultipleZonesDetailV001 from "../../Portal/Accessor/Zone/V001/MultipleZonesDetailV001";
const AccessorZoneRouters = [
  {
    path: "ZoneAssessor/Zones/:designVariationVersionName/:developmentId/:projectId/:designVariationId",
    exact: true,
    requireAuth: true,
    element: <Zones />,
    title: "Zones | AccuRate Enterprise",
  },
  {
    path: "ZoneAssessor/Detail/V001/:projectId/:designVariationId/:zoneId",
    exact: true,
    requireAuth: true,
    element: <ZoneDetailV001 />,
    title: "Zone | AccuRate Enterprise",
  },
  {
    path: "ZoneAssessor/MultipleDetail/V001/:projectId/:designVariationId/:jsonParamHex",
    exact: true,
    requireAuth: true,
    element: <MultipleZonesDetailV001 />,
    title: "Zones | AccuRate Enterprise",
  },
];
export default AccessorZoneRouters;